import {Injector} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {setWidgetSettings, updateWidgetSettings} from '../components/common-widget.implementation';
import {DexDevRatesWidgetSettings} from './settings/dex-dev-rates-widget-settings';
import {DexDevRatesWidgetSettingsService} from './settings/dex-dev-rates-widget-settings.service';

export class DexDevRatesWidgetImplementation implements WidgetImplementation {

    public settings: DexDevRatesWidgetSettings;

    public settingsService: DexDevRatesWidgetSettingsService = this.injector.get(DexDevRatesWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);

    public event$ = new Subject<WidgetImplementationEvent>();

    constructor(
        private injector: Injector
    ) {}

    public setSettings(
        settings?: DexDevRatesWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexDevRatesWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexDevRatesWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexDevRatesWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
